import { storageName } from "../package-instantwinform/config";

export const formSubmissionDateTime = storageName + '-gameStats';
export const gameStatsLabel = storageName + '-gameStats';

export function isToday(date) {

	const subDate = new Date(date),
	  today = new Date(),
	  isSameDay = subDate.getMonth() === today.getMonth() && subDate.getFullYear() === today.getFullYear() && subDate.getDate() === today.getDate();

	//   console.log(subDate.getMonth() , today.getMonth() , subDate.getFullYear() , today.getFullYear() , subDate.getDate() , today.getDate());

	return isSameDay;
}

export function hasSubmittedToday() {
	return isToday(getSubmissionDatetimeFromStorage());
}

export function saveGameStats(data) {
	const 
		date = new Date(),
		month = date.getMonth(),
		year = date.getFullYear(),
		day = date.getDate(),
		dateStr = year + '-' + (month+1) + '-' + day + ' 00:00:00',
		jsonData = Object.assign({lastSave: dateStr},data);

	setJsonDataToStorage(jsonData);
}

export function getTodayGameStats() {
	const 
		jsonData = getJsonDataFromStorage(),
		hasTodayData = jsonData && jsonData.lastSave && isToday(jsonData.lastSave);
// console.log('getTodayGameStats', jsonData, jsonData && jsonData.lastSave && isToday(jsonData.lastSave));
	return (hasTodayData && jsonData) || null;
}

export function getJsonDataFromStorage() {
	return JSON.parse(window.localStorage.getItem(gameStatsLabel));
}

export function setJsonDataToStorage(data) {
	window.localStorage.setItem(gameStatsLabel,JSON.stringify(data));
}

export function setSubmissionDatetimeToStorage(datetimeStr) {
	window.localStorage.setItem(formSubmissionDateTime, datetimeStr);
}

export function getSubmissionDatetimeFromStorage() {
	return window.localStorage.getItem(formSubmissionDateTime);
}